import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from './cookie-consent.service';

@Component({
  selector: 'lib-cookie-consent',
  standalone: true,
  imports: [ButtonModule, RouterLink],
  styles: [`
    .cookie-bar {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      background: var(--surface-card, #1e1e2e);
      border-top: 1px solid var(--surface-border, #313244);
      padding: 1rem 2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;
      backdrop-filter: blur(8px);
      box-shadow: 0 -4px 24px rgba(0,0,0,0.3);
      animation: slideUp 0.3s ease-out;
    }

    @keyframes slideUp {
      from { transform: translateY(100%); opacity: 0; }
      to   { transform: translateY(0);   opacity: 1; }
    }

    .cookie-text {
      flex: 1;
      font-size: 0.875rem;
      color: var(--text-color-secondary, #a6adc8);
      min-width: 240px;
    }

    .cookie-text a {
      color: var(--primary-color, #89b4fa);
      text-decoration: underline;
      cursor: pointer;
    }

    .cookie-actions {
      display: flex;
      gap: 0.75rem;
      flex-shrink: 0;
    }
  `],
  template: `
    @if (consentService.$status() === null) {
      <div class="cookie-bar" role="dialog" aria-label="Aviso de cookies">
        <p class="cookie-text">
          🍪 Utilizamos <strong>Microsoft Clarity</strong> e <strong>Google Ads</strong> para análise de comportamento,
          melhoria de experiência e medição de campanhas. Nenhum dado pessoal identificável é enviado.
          <a [routerLink]="['/privacidade']">Ver nossa Política de Privacidade.</a>
        </p>
        <div class="cookie-actions">
          <p-button
            label="Rejeitar"
            severity="secondary"
            [text]="true"
            size="small"
            (onClick)="consentService.rejeitar()"
          />
          <p-button
            label="Aceitar Todos"
            severity="primary"
            size="small"
            (onClick)="consentService.aceitar()"
          />
        </div>
      </div>
    }
  `,
})
export class CookieConsentComponent {
  consentService = inject(CookieConsentService);
}
